<template>
  <div
    class="dataTables_scrollBody"
    style="font-size: 14px; position: relative; overflow: auto; max-height: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;"
  >
    <b-table-simple
      class="ncut-table-menu-striped ncut-table-menu"
      responsive
      bgcolor="#FFFFFF"
    >
      <b-thead class="ncut-thead-menu">
        <b-tr>
          <th style="min-width: 2em">姓名</th>
          <b-th style="min-width: 2em">人次</b-th>
          <b-th style="min-width: 2em">管理</b-th>
        </b-tr>
      </b-thead>

      <b-tbody>
        <b-tr
          v-for="(data, index) in list"
          :key="data.aid"
          @click="$emit('rowClick', index)"
        >
          <b-td style="text-align: center">
            {{ data.deparment + data.pro_Title + data.name + data.updateUser }}
          </b-td>

          <b-td style="text-align: center">
            {{ data.number }}
          </b-td>

          <b-td v-if="data.number > 0">
            <button
              @click.prevent="$emit('viewDetail', data)"
              class="btn btn-outline-info"
              type="button"
              style="font-size: 14px"
            >
              查閱
            </button>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  props: ["list"],
};
</script>
